const Container = require('components/Container/Container');
module.exports = Container;
